var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalTrips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M34.9951 0C43.2793 8.70245e-05 49.9951 6.71578 49.9951 15V35C49.9951 43.2842 43.2793 49.9999 34.9951 50H15C6.71573 50 3.22151e-07 43.2843 0 35V15C3.22152e-07 6.71573 6.71573 0 15 0H34.9951Z",
    fill: "#2E9F45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    d: "M32.4956 19.667C34.5666 19.6672 36.2456 21.458 36.2456 23.667C36.2454 25.8758 34.5665 27.6668 32.4956 27.667C30.4246 27.667 28.7449 25.8759 28.7446 23.667C28.7446 21.4579 30.4244 19.667 32.4956 19.667ZM21.2476 13C24.009 13 26.2484 15.3876 26.2485 18.333C26.2485 21.2785 24.0091 23.667 21.2476 23.667C18.4862 23.6667 16.2476 21.2784 16.2476 18.333C16.2477 15.3878 18.4863 13.0003 21.2476 13Z",
    fill: "#2E9F45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2243 26.3335C27.2086 26.3336 32.1255 29.3911 32.4919 35.9331C32.5065 36.1937 32.4914 37.0005 31.5525 37.0005H10.905C10.5915 37.0005 9.96942 36.2788 9.99581 35.9321C10.4804 29.5687 15.3229 26.3335 21.2243 26.3335ZM31.9968 29.0024C36.255 29.0518 39.7321 31.3465 39.9939 36.1997C40.0044 36.3951 39.9938 37.0002 39.3161 37.0005H34.4958C34.4958 33.9996 33.5653 31.2306 31.9968 29.0024Z",
    fill: "#2E9F45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTrips);
export default __webpack_public_path__ + "static/media/TotalTrips.1aeafdee658e4992c2a5239631ff736f.svg";
export { ForwardRef as ReactComponent };